import { use } from "react";

import { FeaturesContext, UserContext } from "@/contexts";

function useHasMultientityDashboard() {
  const { featureFlags } = use(FeaturesContext);
  const { user } = use(UserContext);

  return Boolean(
    featureFlags?.["multientity_dashboard"] && user?.subsidiaries.length
  );
}

export default useHasMultientityDashboard;
